import React from "react";
import { Link } from "react-router-dom";
import {
  AppstoreOutlined,
  TeamOutlined,
  BuildOutlined,
  CloudServerOutlined,
  HistoryOutlined,
} from "@ant-design/icons";

/**
 * Widget registry - defines all available dashboard widgets,
 * their default visibility per role, and responsive grid spans.
 *
 * `component` is the filename under ./widgets/ used by React.lazy().
 */
export const widgetRegistry = [
  {
    id: "super-user",
    title: "Organizzazioni",
    defaultRoles: ["admin", "cs"],
    defaultSpan: { xs: 24, sm: 24, md: 7, lg: 7, xl: 7 },
    component: "SuperUserWidget",
    headerExtra: (
      <Link to="/orgs" style={{ fontSize: 12, color: "#888", display: "flex", alignItems: "center", gap: 4 }}>
        Vedi tutte <TeamOutlined />
      </Link>
    ),
  },
  {
    id: "quick-links",
    title: "Link Rapidi",
    defaultRoles: ["admin", "cs", "guest"],
    defaultSpan: { xs: 24, sm: 24, md: 13, lg: 13, xl: 13 },
    component: "QuickLinksWidget",
    headerExtra: (
      <Link to="/apps" style={{ fontSize: 12, color: "#888", display: "flex", alignItems: "center", gap: 4 }}>
        Vedi tutti <AppstoreOutlined />
      </Link>
    ),
  },
  {
    id: "preview-envs",
    title: "Preview Environments",
    defaultRoles: ["admin"],
    defaultSpan: { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 },
    component: "PreviewEnvsWidget",
    headerExtra: (
      <Link to="/servizi" style={{ fontSize: 12, color: "#888", display: "flex", alignItems: "center", gap: 4 }}>
        Gestisci <CloudServerOutlined />
      </Link>
    ),
  },
  {
    id: "build-status",
    title: "Aggiornamenti Piattaforma",
    defaultRoles: ["admin", "cs"],
    defaultSpan: { xs: 24, sm: 24, md: 10, lg: 10, xl: 10 },
    component: "BuildStatusWidget",
    headerExtra: (
      <Link to="/ci" style={{ fontSize: 12, color: "#888", display: "flex", alignItems: "center", gap: 4 }}>
        Vedi tutti <BuildOutlined />
      </Link>
    ),
  },
  {
    id: "eterno-changelog",
    title: "Eterno - Changelog",
    defaultRoles: ["admin", "cs"],
    defaultSpan: { xs: 24, sm: 24, md: 14, lg: 14, xl: 14 },
    component: "EternoChangelogWidget",
    headerExtra: (
      <Link to="/ci" style={{ fontSize: 12, color: "#888", display: "flex", alignItems: "center", gap: 4 }}>
        Tutte le build <HistoryOutlined />
      </Link>
    ),
  },
  {
    id: "panic-button",
    title: "Panic Button — Allerta On-Call",
    defaultRoles: ["admin", "cs"],
    defaultSpan: { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 },
    component: "PanicButtonWidget",
  },
];
